export default __webpack_public_path__ + "static/media/ic_search.752f7f08.svg";